module.exports = __webpack_public_path__ + "img/pns_float_ico.7ee114f2.png";